/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_In_Transit_Requirements_TitleInputs */

const en_orders_in_transit_requirements_title = /** @type {(inputs: Orders_In_Transit_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver details required before moving to In Transit`)
};

const es_orders_in_transit_requirements_title = /** @type {(inputs: Orders_In_Transit_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requieren datos del chofer antes de mover a En transito`)
};

/**
* | output |
* | --- |
* | "Driver details required before moving to In Transit" |
*
* @param {Orders_In_Transit_Requirements_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_in_transit_requirements_title = /** @type {((inputs?: Orders_In_Transit_Requirements_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_In_Transit_Requirements_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_in_transit_requirements_title(inputs)
	return es_orders_in_transit_requirements_title(inputs)
});